import React, { useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TdImg from './TdImg';
import { Link } from 'react-router-dom';
import { Typography } from '@material-tailwind/react';
import LinearProgress from '@mui/material/LinearProgress';
import { overflowMui } from '../ThemeMode/stylesMui';
import TableNotFound from './TableNotFound';
import { convertToInt } from '../../hook/convertQuantidade';

export default function TableMui({ columns, rows, search, loading }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  useEffect(() => {
    setPage(0);
  }, [search]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Paper
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
      }}
    >
      <TableContainer
        sx={{
          maxHeight: '90%',
          height: '100%',
          minWidth: 600,
          ...overflowMui(),
        }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    width: column.width,
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan={4}>
                  <LinearProgress />
                </TableCell>
              </TableRow>
            )}
            {rows.length === 0 && !loading && <TableNotFound />}
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
              <TableRow hover role="row" tabIndex={-1} key={index}>
                {columns.map((column) => {
                  if (column.id === 'nome') {
                    // Renderiza o avatar junto com o nome
                    return (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        sx={{ borderBottom: '1px solid #fff' }}
                      >
                        <div className="flex items-center space-x-2">
                          <TdImg foto={row.foto} />
                          <div className="flex flex-col">
                            <Link to={`/${row.winthor}`}>
                              <Typography
                                color="white"
                                variant="small"
                                className="font-extrabold uppercase hover:underline text-black dark:text-black"
                              >
                                {row.nome}
                              </Typography>
                            </Link>
                            <Typography
                              variant="small"
                              className="font-normal text-xs dark:text-black uppercase"
                            >
                              {row.descricao}
                            </Typography>
                          </div>
                        </div>
                      </TableCell>
                    );
                  }
                  const value = row[column.id];
                  return (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      sx={{ borderBottom: '1px solid #fff' }}
                    >
                      <Typography
                        variant="small"
                        color="white"
                        className={`whitespace-nowrap text-ellipsis text-black dark:text-black ${
                          column.id == 'quantidade_total' && 'bg-[rgba(255,255,255,0.6)]'
                        } p-1 rounded-md text-center font-bold ${
                          column.id == 'quantidade_total' && value == 0 && '!text-red-500'
                        }`}
                      >
                        {column.id == 'quantidade_total' ? convertToInt(value) : value}
                      </Typography>
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`} item`
        }
        labelRowsPerPage="Por página:"
        // sx={{
        //   '& .MuiTablePagination-caption, & .MuiTablePagination-toolbar': {
        //     fontWeight: 'bold', // Define o texto como negrito
        //   },
        //   color: `${theme && '#000'}`,
        //   // marginTop: 2,
        //   '& .MuiSvgIcon-root': {
        //     color: `${theme && '#000'}`, // Altera a cor dos ícones de navegação
        //   },
        // }}
      />
    </Paper>
  );
}
